// Diccionarios de idiomas de la web. FASE 1: español (original) e inglés.
// Para añadir japonés más adelante basta con crear aquí un bloque "ja" con las
// mismas claves y añadir "ja" a LANGS en LanguageContext.js + un botón en el
// selector. Los textos de solo-admin (Desconectarse, Editar…, Subir…) NO se
// traducen a propósito: el panel lo usa la propietaria, que trabaja en español.
export const translations = {
  es: {
    nav: {
      reserve: "RESERVAR",
      about: "SOBRE NOSOTROS",
      menu: "CARTA",
      contact: "CONTACTO",
      work: "TRABAJA CON NOSOTROS",
    },
    hero: {
      h1: "Restaurante japonés izakaya en Barcelona · Sushi, wagyu A5 y sake",
    },
    about: {
      title: "SUN TAKA",
      body: [
        "Sun Taka es un concepto de Izakaya situado en Barcelona, un estilo de taberna japonesa. Su cálido y tradicional ambiente pero a su vez elegante, lo hacen especialmente acogedor.",
        "Se respira la esencia de los restaurantes clásicos japoneses. Su cocina es muy diversa y variada y ofrece un viaje gastronómico a través de una carta muy amplia: pescado, marisco, sushi, carne, wagyu A5.",
        "Siempre apostando por un producto de calidad y de temporada, elaborado con máxima delicadeza y frescura, manteniendo las técnicas tradicionales japonesas.",
        "Destaca su carta de sakes originarios de Japón y una amplia carta de vinos nacionales e internacionales que no pasarán desapercibidos.",
      ],
    },
    chef: {
      title: "EL CHEF",
      body: [
        "Mitsutaka Kawata, conocido como “Taka”, es un chef y viajero originario de Osaka (Japón). Cuando tenía 19 años en uno de sus viajes fuera de Japón, tomó la decisión de convertirse en cocinero para difundir su propio concepto de cocina japonesa. Taka se inspiró en su maestro Nakamura, donde se formó durante 8 años en cocina tradicional japonesa en el restaurante Wayo Yuzen Nakamura en su Osaka natal.",
        "Cuando se estableció en España, tuvo la oportunidad de trabajar en lugares prestigiosos como Baluarte, Can Fabes (Sant Celoni) y en Hotel Ferrero al lado de Chefs internacionales reconocidos. Además, montó la barra de sushi del Cercle d'Artistes, en Barcelona, donde fue el Chef por más de 5 años.",
        "Con una visión muy clara en encontrar una expresión moderna y fresca de la gastronomía japonesa, abre una nueva etapa creando su propia Izakaya, un estilo de taberna japonesa en Barcelona y así nace el restaurante Sun Taka.",
        "Actualmente cuenta con el soporte de excelentes cocineros japoneses que se destacan por su capacidad de crear “platos familiares” con un toque personalizado, creando una fusión de sabores que constituyen una obra única.",
        "La determinación de sus manos y los minuciosos cortes de cuchillo hacen que observar a Taka en la barra se convierta en un espectáculo gastronómico.",
      ],
    },
    menu: {
      title: "LA CARTA",
      quote:
        "“Creo fundamentalmente en respetar cada regalo que la naturaleza nos hace.”",
      card: "CARTA",
      suggestions: "SUGERENCIAS",
      desserts: "POSTRES",
      cellar: "BODEGA",
      sake: "SAKE",
      whisky: "WHISKY",
    },
    reservations: {
      title: "RESERVAS",
      callToReserve: "Reserva llamando al",
      onlineReserve: "Reserva online",
    },
    reviews: {
      title: "LO QUE DICEN DE NOSOTROS",
      cta: "Cuéntanos tu experiencia",
    },
    footer: {
      contact: "Contacto",
      address: "Dirección: Carrer del Bruc, 146, 08037 Barcelona",
      phone: "Teléfono: 932 50 23 49",
      email: "Email: suntakabarcelona@gmail.com",
      hours: "Horarios",
      days: "Miércoles a Domingo",
      hoursDetail: "Mediodía: 13.00h-15.30h; Noche: 20.00h-23.00h",
      closed: "Lunes y Martes cerrado",
      copyright: "Copyright © 2023 Sun Taka. All Rights Reserved.",
    },
  },

  en: {
    nav: {
      reserve: "BOOK",
      about: "ABOUT US",
      menu: "MENU",
      contact: "CONTACT",
      work: "WORK WITH US",
    },
    hero: {
      h1: "Japanese izakaya restaurant in Barcelona · Sushi, A5 wagyu and sake",
    },
    about: {
      title: "SUN TAKA",
      body: [
        "Sun Taka is an izakaya concept located in Barcelona, a style of traditional Japanese tavern. Its warm and traditional yet elegant atmosphere makes it especially welcoming.",
        "It breathes the essence of classic Japanese restaurants. Its cuisine is diverse and varied, offering a gastronomic journey through an extensive menu: fish, seafood, sushi, meat and A5 wagyu.",
        "Always committed to quality, seasonal produce, prepared with the utmost delicacy and freshness while preserving traditional Japanese techniques.",
        "Its selection of sakes from Japan stands out, alongside an extensive list of national and international wines that will not go unnoticed.",
      ],
    },
    chef: {
      title: "THE CHEF",
      body: [
        "Mitsutaka Kawata, known as “Taka”, is a chef and traveller from Osaka, Japan. At the age of 19, during one of his trips outside Japan, he decided to become a cook to share his own vision of Japanese cuisine. Taka drew inspiration from his master Nakamura, training for 8 years in traditional Japanese cuisine at the Wayo Yuzen Nakamura restaurant in his native Osaka.",
        "After settling in Spain, he had the opportunity to work in prestigious places such as Baluarte, Can Fabes (Sant Celoni) and Hotel Ferrero, alongside renowned international chefs. He also set up the sushi bar at the Cercle d'Artistes in Barcelona, where he was head chef for more than 5 years.",
        "With a clear vision of finding a modern, fresh expression of Japanese gastronomy, he opened a new chapter by creating his own izakaya — a style of Japanese tavern in Barcelona — and so the Sun Taka restaurant was born.",
        "Today he is supported by excellent Japanese cooks who stand out for their ability to create “home-style dishes” with a personal touch, creating a fusion of flavours that becomes a unique work of art.",
        "The determination of his hands and his meticulous knife work turn watching Taka at the bar into a true gastronomic spectacle.",
      ],
    },
    menu: {
      title: "THE MENU",
      quote:
        "“I fundamentally believe in respecting every gift that nature gives us.”",
      card: "MENU",
      suggestions: "SPECIALS",
      desserts: "DESSERTS",
      cellar: "WINE LIST",
      sake: "SAKE",
      whisky: "WHISKY",
    },
    reservations: {
      title: "RESERVATIONS",
      callToReserve: "Book by calling",
      onlineReserve: "Book online",
    },
    reviews: {
      title: "WHAT THEY SAY ABOUT US",
      cta: "Share your experience",
    },
    footer: {
      contact: "Contact",
      address: "Address: Carrer del Bruc, 146, 08037 Barcelona",
      phone: "Phone: 932 50 23 49",
      email: "Email: suntakabarcelona@gmail.com",
      hours: "Opening hours",
      days: "Wednesday to Sunday",
      hoursDetail: "Lunch: 1.00–3.30 pm; Dinner: 8.00–11.00 pm",
      closed: "Closed on Monday and Tuesday",
      copyright: "Copyright © 2023 Sun Taka. All Rights Reserved.",
    },
  },

  // BORRADOR de japonés — pendiente de revisión por el chef (nativo). Los
  // nombres propios (Mitsutaka Kawata, Wayo Yuzen Nakamura) van en romaji para
  // que él los ponga en kanji si lo prefiere.
  ja: {
    nav: {
      reserve: "ご予約",
      about: "当店のご紹介",
      menu: "メニュー",
      contact: "お問い合わせ",
      work: "採用情報",
    },
    hero: {
      h1: "バルセロナの居酒屋・日本料理店 · 寿司、A5和牛、日本酒",
    },
    about: {
      title: "SUN TAKA",
      body: [
        "Sun Taka は、バルセロナにある居酒屋スタイルの日本料理店です。温かみのある伝統的な雰囲気と上品さを兼ね備え、とても居心地の良い空間となっています。",
        "店内には日本の伝統的な料理店の趣が漂います。料理は多彩で、魚、魚介、寿司、肉、A5和牛など、幅広いメニューを通して美食の旅をお楽しみいただけます。",
        "旬の上質な食材にこだわり、日本の伝統的な技法を守りながら、繊細さと新鮮さを大切に調理しています。",
        "日本各地から取り寄せた日本酒のリストや、国内外の豊富なワインの品揃えも自慢です。",
      ],
    },
    chef: {
      title: "シェフ",
      body: [
        "「Taka」の愛称で親しまれる Mitsutaka Kawata は、大阪出身の料理人であり旅人です。19歳のとき、日本国外を旅する中で、自身の考える日本料理を広めるために料理人になることを決意しました。故郷・大阪の「Wayo Yuzen Nakamura」で、恩師である中村氏のもと8年間にわたり日本の伝統料理を学び、大きな影響を受けました。",
        "スペインに移り住んでからは、Baluarte、Can Fabes（サン・セローニ）、Hotel Ferrero といった名店で、世界的に著名なシェフたちとともに働く機会に恵まれました。さらに、バルセロナの Cercle d'Artistes では寿司カウンターを立ち上げ、5年以上にわたってシェフを務めました。",
        "日本の食文化を現代的で新鮮に表現したいという明確な思いのもと、彼は新たな一歩を踏み出し、自身の居酒屋をバルセロナに開きます。こうして生まれたのがレストラン Sun Taka です。",
        "現在は、優れた日本人料理人たちがその活動を支えています。彼らは「家庭的な料理」に個性的なひと工夫を加えることに長け、独創的な一皿となる味の調和を生み出しています。",
        "迷いのない手さばきと繊細な包丁使いによって、カウンターに立つ Taka の姿は、まさに美食のショーとなります。",
      ],
    },
    menu: {
      title: "お品書き",
      quote:
        "「自然が与えてくれる一つひとつの恵みを大切にすること。それが私の料理の根本にある信念です。」",
      card: "メニュー",
      suggestions: "おすすめ",
      desserts: "デザート",
      cellar: "ワインリスト",
      sake: "日本酒",
      whisky: "ウイスキー",
    },
    reservations: {
      title: "ご予約",
      callToReserve: "お電話でのご予約はこちら",
      onlineReserve: "オンライン予約",
    },
    reviews: {
      title: "お客様の声",
      cta: "ご感想をお聞かせください",
    },
    footer: {
      contact: "お問い合わせ",
      address: "住所：Carrer del Bruc, 146, 08037 Barcelona",
      phone: "電話：932 50 23 49",
      email: "メール：suntakabarcelona@gmail.com",
      hours: "営業時間",
      days: "水曜日〜日曜日",
      hoursDetail: "昼：13:00〜15:30／夜：20:00〜23:00",
      closed: "月曜・火曜定休",
      copyright: "Copyright © 2023 Sun Taka. All Rights Reserved.",
    },
  },
};
